import { render, staticRenderFns } from "./LastArticle.vue?vue&type=template&id=8a552360&"
import script from "./LastArticle.vue?vue&type=script&lang=js&"
export * from "./LastArticle.vue?vue&type=script&lang=js&"
import style0 from "./LastArticle.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports